import { AgentClient } from '~/agents/common/client/agent'
import { TabPostsIcon } from '~/features/chatV3/client/components/HeaderV2/components/Tabs/components/TabPostsIcon'
import { Icon } from '~/features/shared/icons'
import { SocialMediaManagerCommon } from '../common'

export const SocialMediaManagerAgent: AgentClient = {
  key: SocialMediaManagerCommon.Agent.key,

  getTabs: ({ appSession, pathBase }) => [
    {
      to: `${pathBase}/posts`,
      icon: <TabPostsIcon appSession={appSession} />,
      label: 'Posts',
    },
    {
      to: `${pathBase}/guidelines`,
      icon: <Icon name="sticky-notes" />,
      label: 'Guidelines',
    },
  ],
}
